import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/contractGroups', request)
}

export {get}
